import type { ApiClient } from "@/common/api/http/types";

interface TrackEventPayload {
  event_name: string;
  source: string;
  session_id: string;
  properties: Record<string, string | number | boolean | null | undefined>;
  page_path: string;
  username: string | null;
}

export default class EventsService {
  public constructor(private readonly client: ApiClient) {}

  async track(payload: TrackEventPayload): Promise<void> {
    return await this.client.beacon<void, TrackEventPayload>("v2/events/track", payload);
  }
}
